// "이 PC" 판정 — 순수 함수·문구(의존성 0: Node 단위 시험이 그대로 불러온다). 훅은 `views/myConnection/useMyDeviceCode.ts`.
// 2026-09-29 사용자 요청: 이 앱이 돌고 있는 PC 는 기기 목록에 보이되 "이 PC" 로 표시하고 접속은 막는다
// (자기 화면을 자기가 받으면 거울 속 거울처럼 화면이 겹치고, 입력이 자기 자신에게 되돌아온다).

/** 목록에서 이 PC 행에 붙이는 표시. */
export const SELF_DEVICE_BADGE = '이 PC';
/** 이 PC 행의 [접속] 설명 · 코드 접속을 막을 때 안내. */
export const SELF_CONNECT_BLOCKED = '지금 이 앱이 실행 중인 PC 입니다 — 자기 자신에게는 접속할 수 없습니다.';

/** 기기 코드처럼 생긴 입력(숫자·하이픈·공백만) — agentId(UUID)와 구분한다. */
const DEVICE_CODE_SHAPE = /^[\d\s-]+$/;

/** 비교용 정규화 — 표기(`123-456-789`·`123456789`·공백)와 무관하게 숫자만 남긴다. */
export function normalizeDeviceCode(code: string | null | undefined): string {
  return (code ?? '').replace(/\D/g, '');
}

/**
 * 두 기기 코드가 같은 기기인가. 한쪽이라도 비었거나 코드 모양이 아니면 false
 * (모르면 막지 않는다 — 브라우저 뷰어·정체성 도착 전 · agentId 로 접속하는 기기 목록).
 */
export function isSameDeviceCode(a: string | null | undefined, b: string | null | undefined): boolean {
  if (!a || !b || !DEVICE_CODE_SHAPE.test(a) || !DEVICE_CODE_SHAPE.test(b)) return false;
  const na = normalizeDeviceCode(a);
  return na.length > 0 && na === normalizeDeviceCode(b);
}
